module.exports = __webpack_public_path__ + "img/pdf.c3d800c8.png";